<nav id="mobile-content-navigation" class="mobile-content-navigation" *ngIf="links.length" [attr.aria-label]="ariaLabel">
    <div class="nav-bar">
        <finder-button *ngIf="activeLink"
            class="active-link"
            [id]="'mobile-content-navigation-button'"
            theme="reversed"
            [ariaControls]="'mobile-content-navigation-menu'"
            [ariaExpanded]="displayedList"
            [ariaHasPopup]="true"
            (click)="displayList()">
            <finder-font-icon
                *ngIf="activeLink.icon"
                [svgSrc]="activeLink.icon.src"
                size="xs"
            >
            </finder-font-icon>
            <span class="active-link-label">{{activeLink.title}}</span>
            <finder-font-icon name="icon_expand-show-more" size="inherit" [class.reversed]="displayedList" class="active-link-expand-icon"></finder-font-icon>
        </finder-button>
        <finder-button finderClickScrollTo scrollId="{{cta.href}}" offsetElement="#mobile-content-navigation" class="cta" *ngIf="cta" [href]="cta.href" theme="primary">
            <span class="cta-label">{{cta.title}}</span>
        </finder-button>
    </div>
    <div *ngIf="displayedList"
        class="list"
        id="mobile-content-navigation-menu"
        aria-labelledby="mobile-content-navigation-button"
        role="menu"
        @listState>
        <finder-picture *ngIf="logo" class="logo" [picture]="logo"></finder-picture>
        <finder-anchor finderClickScrollTo scrollId="{{link.href}}" offsetElement="#mobile-content-navigation" *ngFor="let link of links"
            class="link"
            [href]="link.href"
            [role]="'menuitem'"
            [class.active]="link === activeLink"
            (click)="handlePageAnchor($event, link)"
        >
            <div class="link-inner">
                <div class="link-content">
                    <finder-font-icon
                        *ngIf="link.icon"
                        [svgSrc]="link.icon.src"
                        size="xs"
                    >
                    </finder-font-icon>
                    <span class="link-label">{{link.title}}</span>
                </div>
            </div>
        </finder-anchor>
    </div>
</nav>
